import React from "react"
import "../components/footer.scss"
import { StaticImage } from "gatsby-plugin-image"
import footerLogo from "../images/LOGO_PJM.svg"
import AniLink from "gatsby-plugin-transition-link/AniLink";

export default function Footer(props) {
    // console.log(props);
    return (
        <footer className="footer">
            <div className={"row row-wrapper footer--top " + ((props.prevLink !== "" && props.nextLink !== "") ? "row-reverse-desktop" : null)}>
                { props.nextLink !== "" &&
                    <div className={"col-xs-12 col-md-6 prev " + (props.prevLink === "" ? "col-md-offset-3" : null)}>
                        <div className="nav-item">
                            <AniLink fade to={props.nextLink} duration={1}>
                                <div className="profile">
                                    <img className={`${props.nextRings === "" ? 'square' : null} bio`} src={props.nextImage} alt="" />
                                    { props.nextRings !== "" &&
                                        <img className="rings" src={props.nextRings} alt="" />
                                    }
                                </div>
                                <div className="text--outline text--blue">{props.nextText}</div>
                                <div className="text--title text--blue">{props.nextTitle}</div>
                            </AniLink>
                        </div>
                    </div>
                }
                { props.prevLink !== "" &&
                    <div className={"col-xs-12 col-md-6 next " + (props.nextLink === "" ? "col-md-offset-3" : null)}>
                        <div className="nav-item">
                            <AniLink fade to={props.prevLink} duration={1}>
                                <div className="profile">
                                    <img className={`${props.prevRings === "" ? 'square' : null} bio`} src={props.prevImage} alt="" />
                                    { props.prevRings !== "" &&
                                        <img className="rings" src={props.prevRings} alt="" />
                                    }
                                </div>
                                <div className="text--outline text--blue">{props.prevText}</div>
                                <div className="text--title text--blue">{props.prevTitle}</div>
                            </AniLink>
                        </div>
                    </div>
                }
            </div>
            <div className="divider"></div>
            <div className="row full-width-row footer--bottom">
                <div className="col-xs-12 col-md-6">
                    <div className="footer-logo">
                        <img src={footerLogo} alt=""/>
                        <div className="text--blue">Working to Perfect the Flow of Energy</div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-6">
                    <div className="footer-text">
                        <div className="text--gray">For information, please contact: (866) 400-8980 • PJM.com</div>
                        <div className="text--gray">“PJM” is a registered trademark of PJM Interconnection, L.L.C.</div>
                        <div className="text--gray">PJM ©2022 All rights reserved</div>
                    </div>
                </div>
            </div>
        </footer>
    )
}